module.exports = __webpack_public_path__ + "img/1.f04dd894.png";